import controller from './controller';
import template from './template.html';
import styles from './styles.less';

routes.$inject = ['$stateProvider', '$urlRouterProvider'];

export default function routes($stateProvider, $urlRouterProvider){

	$stateProvider.state('termsOfService', {
		url: '/termsOfService',
		controllerAs: 'ctrl',
		controller: controller,
		template: template,
        params: {
            termsOfServiceId: {
                type: "int",
                value: null,
            },
        },
	})


}


/** WEBPACK FOOTER **
 ** ./src/guest/termsOfService/routes.js
 **/